import * as React from 'react'
import { useEffect } from 'react'
import { AppAction } from '../../../config/appConfig'
import { MenuItemKey } from '../../../components/MainMenu'
import BaseTimeOverview, { BaseTimeOverviewProps } from './BaseTimeOverview'
import { useDispatch } from 'react-redux'
import { FileAction } from '../../../config/fileConfig'

export default function GlobalTimeOverview(props: BaseTimeOverviewProps) {
    const dispatch = useDispatch()

    //Reset breadcrumbs and data
    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Times] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    return <BaseTimeOverview {...props} localStorageKeyPrefix={'HammockGlobalTimeOverview'} />
}
